import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Table, Icon, Input } from 'semantic-ui-react';
import API from '../../../../../utils/API';
import DeleteConfirmPopup from '../../../../Common/DeleteConfirmPopup';
import { toastSuccess } from '../../../../../utils/toastMessage';

const ProductListItem = React.memo(({ id, name, onEdit, onDelete }) => {
  const [isEditableName, setIsEditableName] = useState(false);
  const [currentProductName, setCurrentProductName] = useState(name);
  const [isError, setIsError] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);

  const toggleDeleteModal = () => {
    setDeleteModal(!isDeleteModal);
  };

  const onEditClick = React.useCallback(() => {
    setIsEditableName(true);
  });

  const onChangeName = React.useCallback((e) => {
    if (isError) setIsError(false);
    setCurrentProductName(e.target.value);
  });

  const applyChanges = React.useCallback(() => {
    const trimmedCurrentProductName = currentProductName.trim();
    if (
      trimmedCurrentProductName === '' ||
      trimmedCurrentProductName.length < 2 ||
      trimmedCurrentProductName.length > 50
    ) {
      setIsError(true);
      return;
    }
    setIsLoadingEdit(true);
    API.put(`/product/${id}`, {
      name: currentProductName,
    })
      .then(() => {
        onEdit(currentProductName, id);
        setIsEditableName(false);
        setIsLoadingEdit(false);
      })
      .catch(() => {
        setIsLoadingEdit(false);
      });
  });

  const discardChanges = React.useCallback(() => {
    setCurrentProductName(name);
    setIsEditableName(false);
  });

  const onDeleteClick = React.useCallback((productId) => {
    setIsLoadingDelete(true);
    API.delete(`/product/${productId}`)
      .then(() => {
        setIsLoadingDelete(false);
        onDelete(productId); // delete product in storage
        toastSuccess('Ингредиент успешно удален');
      })
      .catch(() => {
        setIsLoadingDelete(false);
      });
  });

  return (
    <Table.Row>
      <Table.Cell>
        {isEditableName ? (
          <React.Fragment>
            <Input value={currentProductName} onChange={onChangeName} error={isError} />
            {isError && (
              <ErrorText>Название ингридиента должно содержать от 2х до 50ти символов</ErrorText>
            )}
          </React.Fragment>
        ) : (
          <div>{currentProductName}</div>
        )}
      </Table.Cell>
      <Table.Cell style={{ display: 'flex' }}>
        {isEditableName ? (
          <React.Fragment>
            <Button onClick={applyChanges} loading={isLoadingEdit} color="green" icon>
              <Icon name="save" />
            </Button>
            {!isLoadingEdit && (
              <Button onClick={discardChanges} icon>
                <Icon name="share" />
              </Button>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button onClick={onEditClick} color="blue" icon>
              <Icon name="edit" />
            </Button>
            <Button onClick={toggleDeleteModal} color="red" icon loading={isLoadingDelete}>
              <Icon name="delete" />
            </Button>
          </React.Fragment>
        )}
      </Table.Cell>
      <DeleteConfirmPopup
        isLoadingDelete={isLoadingDelete}
        isOpen={isDeleteModal}
        title={currentProductName}
        onDelete={() => onDeleteClick(id)}
        onCancel={toggleDeleteModal}
      />
    </Table.Row>
  );
});

export default ProductListItem;

const ErrorText = styled.div`
  color: red;
  margin: 5px 0px;
  font-size: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/Products/ProductListItem.jsx